module.exports = require('./helpers/bundle-url').getBundleURL('5992T') + "logo-dark.bdeff35f.svg";